import React, { useEffect, useState } from 'react';
import { Modal, Checkbox, List, Spin, Button, Row, Col, DatePicker, Space, Typography, Alert } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'dayjs';

const { RangePicker } = DatePicker;
const { Text } = Typography;

const SyncFinancialModal = ({ visible, onOk, onCancel, loading }) => {
  const sellerAccounts = useSelector(state => state.dataCommon.sellerAccounts);
  const [selectedIds, setSelectedIds] = useState([]);
  const [dateRange, setDateRange] = useState([
    moment().subtract(7, 'days'),
    moment()
  ]);

  useEffect(() => {
    if (visible && sellerAccounts) {
      setSelectedIds(sellerAccounts.map(acc => acc.id)); // Default select all
    }
  }, [visible, sellerAccounts]);

  const onChange = (checkedValues) => {
    setSelectedIds(checkedValues);
  };
  
  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const handleOk = () => {
    // Format dateRange to 'YYYY-MM-DD' format when submitting
    const formattedDateRange = dateRange.map(date => date.format('YYYY-MM-DD'));
    onOk(selectedIds, formattedDateRange);
  };

  return (
    <Modal
      title="Đồng bộ dữ liệu tài chính từ Amazon"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Đồng bộ"
      cancelText="Hủy"
      confirmLoading={loading}
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Alert
          message="Thông tin"
          description="Đồng bộ dữ liệu tài chính sẽ cập nhật các thông tin: giá sản phẩm, phí vận chuyển, phí Amazon, chiết khấu và lợi nhuận cho các đơn hàng trong khoảng thời gian được chọn."
          type="info"
          showIcon
        />

        <div>
          <Text strong>Khoảng thời gian:</Text>
          <RangePicker 
            style={{ width: '100%', marginTop: 8 }}
            value={dateRange}
            onChange={handleDateRangeChange}
          />
          <Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
            Khuyến nghị: Chọn khoảng thời gian không quá 30 ngày để đảm bảo hiệu suất.
          </Text>
        </div>
        
        <div>
          <Text strong>Seller Accounts:</Text>
          {sellerAccounts.length === 0 ? (
            <Spin />
          ) : (
            <>
              <Row gutter={8} style={{ marginTop: 8, marginBottom: 8 }}>
                <Col>
                  <Button size="small" onClick={() => setSelectedIds(sellerAccounts.map(acc => acc.id))}>
                    Chọn tất cả
                  </Button>
                </Col>
                <Col>
                  <Button size="small" onClick={() => setSelectedIds([])}>
                    Bỏ tất cả
                  </Button>
                </Col>
              </Row>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={selectedIds}
                onChange={onChange}
              >
                <List
                  dataSource={sellerAccounts}
                  renderItem={item => (
                    <List.Item>
                      <Checkbox value={item.id}>
                        {item.name} ({item.sellerId})
                      </Checkbox>
                    </List.Item>
                  )}
                />
              </Checkbox.Group>
            </>
          )}
        </div>
      </Space>
    </Modal>
  );
};

export default SyncFinancialModal;
